import React from 'react';
import ModularAppView from './ModularAppView';

export default function WifiApp() {
  return (
    <ModularAppView
      slug="wifi"
      defaultTitle="Wi-Fi"
      defaultIcon="Wifi"
      defaultCategory="Network"
    />
  );
}
